import styled from '@emotion/styled';

const PageWrapper = styled('div')`
    background: white;
    padding: 20px;
    margin-right: auto;
    margin-left: auto;
`;

export default PageWrapper;
